import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/**
 * ネイティブの select。
 * 選択肢が数個の固定リストなので、Radix を持ち込む理由がない。
 */
export function Select({ className, ...props }: ComponentProps<'select'>) {
  return (
    <select
      className={cn(
        'border border-line-bold bg-surface-strong px-3 py-2 text-sm',
        'focus:outline-2 focus:outline-offset-0 focus:outline-brand-700',
        className,
      )}
      {...props}
    />
  );
}
